import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 9.75C2 8.7835 2.7835 8 3.75 8H6.25C6.66421 8 7 8.33579 7 8.75C7 9.16421 6.66421 9.5 6.25 9.5H3.75C3.61193 9.5 3.5 9.61193 3.5 9.75V20.25C3.5 20.3881 3.61193 20.5 3.75 20.5H14.25C14.3881 20.5 14.5 20.3881 14.5 20.25V17.75C14.5 17.3358 14.8358 17 15.25 17C15.6642 17 16 17.3358 16 17.75V20.25C16 21.2165 15.2165 22 14.25 22H3.75C2.7835 22 2 21.2165 2 20.25V9.75Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 3.75C8 2.7835 8.7835 2 9.75 2H20.25C21.2165 2 22 2.7835 22 3.75V14.25C22 15.2165 21.2165 16 20.25 16H9.75C8.7835 16 8 15.2165 8 14.25V3.75ZM9.75 3.5C9.61193 3.5 9.5 3.61193 9.5 3.75V14.25C9.5 14.3881 9.61193 14.5 9.75 14.5H20.25C20.3881 14.5 20.5 14.3881 20.5 14.25V3.75C20.5 3.61193 20.3881 3.5 20.25 3.5H9.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgDuplicate;
